import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

type AnswerValue = string | number | string[] | { value: string; unit: string };

interface QuizState {
  answers: Record<string, AnswerValue>;
  saveAnswer: (stepId: string, value: AnswerValue) => void;
  step: number;
  setStep: (step: number) => void;
  nextStep: () => void;
  reset: () => void;
}

export const useQuizStore = create<QuizState>()(
  persist(
    (set) => ({
      answers: {},
      step: 0,

      saveAnswer: (stepId, value) =>
        set((state) => ({
          answers: {
            ...state.answers,
            [stepId]: value,
          },
        })),

      setStep: (step) => set({ step }),
      nextStep: () => set((state) => ({ step: state.step + 1 })),
      reset: () => set({ step: 0, answers: {} }),
    }),
    {
      name: "quiz-progress-storage",
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);
